import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f04bb262&"
import script from "./index.vue?vue&type=script&lang=ts&setup=true&"
export * from "./index.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./index.vue?vue&type=style&index=0&id=f04bb262&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f04bb262')) {
      api.createRecord('f04bb262', component.options)
    } else {
      api.reload('f04bb262', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f04bb262&", function () {
      api.rerender('f04bb262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/[town-translit]/lpu/[lpu-translit]/otzivi/index.vue"
export default component.exports